import { Component, OnInit, Output, inject } from '@angular/core';
import { ContactDataService } from 'src/app/modules/user-profile/services/contact-data-service';
import { EmailList,PhoneList ,AddressList} from 'src/app/modules/user-profile/models/contact-oeds-person.model';
import { ContactVerificationService } from 'src/app/modules/user-profile/services/contact-verification-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContactMappingService } from 'src/app/modules/user-profile/services/contact-mapping-service';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../../../../shared/components/alert/alert.component';


@Component({
    selector: 'app-contact-verification-review-submit',
    templateUrl: './contact-verification-review-submit.component.html',
    styleUrls: ['./contact-verification-review-submit.component.css'],
    imports: [AlertComponent]
})
export class ContactVerificationReviewSubmitComponent implements OnInit {
  cService = inject(ContactVerificationService);
  cMapService = inject(ContactMappingService);
  cDataService = inject(ContactDataService);
  private spinner = inject(NgxSpinnerService);

  message: string;
  showalert: boolean = false;
  msgtype: string;
  @Output() stepcount: number;
  homeEmail: EmailList;
  officeEmail: EmailList[];
  addressList: AddressList[];
  homePhysicalAddress: AddressList;
  homeMailingAddress: AddressList;
  officePhysicalAddress: AddressList;
  officeMailingAddress: AddressList;

  phoneList: PhoneList[];
  homePhoneDtls: PhoneList;
  officePhoneDtls: PhoneList;
  mobilePhoneDtls: PhoneList;

  isAddressExist: boolean = false;
  isPhoneExist: boolean = false;


  ngOnInit(): void {
    //Mail
    this.homeEmail = this.cService.filterActiveEmailByType(this.cMapService.getOedsEmailTypeKey('Home'), this.cService.oedsPersonCopy.emailList)[0];
    this.officeEmail = this.cService.filterActiveEmailByType(this.cMapService.getOedsEmailTypeKey('Office'), this.cService.oedsPersonCopy.emailList)

    //Address
    this.addressList = this.cService.oedsPersonCopy.addressList;
    this.homePhysicalAddress = this.cService.filterActiveAddressByType(this.cMapService.getOedAddressTypeKey('Physical'), this.cMapService.getOedLocationTypeKey('Home'), this.addressList)[0];
    this.homeMailingAddress = this.cService.filterActiveAddressByType(this.cMapService.getOedAddressTypeKey('Mailing'), this.cMapService.getOedLocationTypeKey('Home'), this.addressList)[0];

    //Phone
    this.phoneList = this.cService.oedsPersonCopy.phoneList;
    this.homePhoneDtls = this.cService.filterActivePhoneByType(this.cMapService.getOedsPhoneTypeKey('Home'), this.phoneList)[0];
    this.mobilePhoneDtls = this.cService.filterActivePhoneByType(this.cMapService.getOedsPhoneTypeKey('Cell'), this.phoneList)[0];

    if (this.cService.isUserOrgMappingExist || this.cService.hasOfficeEmail) 
      this.officeEmail = this.cService.filterActiveEmailByType(this.cMapService.getOedsEmailTypeKey('Office'), this.cService.oedsPersonCopy.emailList)
    if (this.cService.isUserOrgMappingExist || this.cService.hasOfficePhone) 
      this.officePhoneDtls = this.cService.filterActivePhoneByType(this.cMapService.getOedsPhoneTypeKey('Office'), this.phoneList)[0];
    if (this.cService.isUserOrgMappingExist || this.cService.hasOfficePhysicalAddress) 
      this.officePhysicalAddress = this.cService.filterActiveAddressByType(this.cMapService.getOedAddressTypeKey('Physical'), this.cMapService.getOedLocationTypeKey('Office'), this.addressList)[0];
    if (this.cService.isUserOrgMappingExist || this.cService.hasOfficeMailingAddress) 
      this.officeMailingAddress = this.cService.filterActiveAddressByType(this.cMapService.getOedAddressTypeKey('Mailing'), this.cMapService.getOedLocationTypeKey('Office'), this.addressList)[0];
    
  }
  updatestep(value: number, actionname: string, addresstype: AddressList, phonetype: PhoneList): void {
    if (this.cService.isUserOrgMappingExist === false && value > 3)
      value=value-1
    this.cService.stepCount = value;
    this.cService.action = actionname;
    this.cService.selectedaddress = addresstype;
    this.cService.selectedphone = phonetype;
    switch (value) {
      case 2: {
        this.cService.setStep('Personal Email');
        break;
      }
      case 3: {
        this.cService.setStep('Office Email');
        break;
      }
      case 4: {
        this.cService.setStep('Address');
        break;
      }
      case 5: {
        this.cService.setStep('Phone');
        break;
      }
    }
  }
  updatestepcount() {
    this.cService.isBackNav = true;
    this.cService.setStep('Phone')
    this.cService.stepCount--;
  }
  submitContactVerification() {
    if (environment.debug) console.log("Final Step OEDS Person Object before cleanup:" + JSON.stringify(this.cService.oedsPersonCopy));
    this.cService.cleanUpJsonObject();
    if (environment.debug) console.log("Final Step OEDS Person Object:" + JSON.stringify(this.cService.oedsPersonCopy));
    this.updatePersonContactDtls();
    //If Ohid Email Changed after last contact verification call ohid email update service
    //if (this.cService.ohidEmailChanged) {
    //  this.UpdateOhidEmail();
    //}
  }
  updateContactverificationDate() {
    var objdata = {
      OaksId: this.cService.tokenDtls.oaksId,
      OhidEmailAddr: this.cService.tokenDtls.ohidEmail,
      PersonKey: this.cService.personkey
    }

    this.cDataService.updateContactverificationDate(objdata).subscribe({
      next: (response) => {
        if (response) {
          this.syncDataToMdm();
          this.spinner.hide();
          this.cService.stepCount = 7;
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.cService.contactVerificationFailed = true;
      }
    });
  }
  
  updatePersonContactDtls() {
    this.spinner.show();
    if (this.cService.oedsPersonCopy.emailList.length === 0
      && this.cService.oedsPersonCopy.phoneList.length === 0
      && this.cService.oedsPersonCopy.addressList.length === 0
      && this.cService.oedsPersonCopy.orgEmailList.length === 0) {
      //No change in Contact Details update Contact verification date
      this.updateContactverificationDate();
    }
    else {
      this.cDataService.updatePersonContactDtls(this.cService.oedsPersonCopy).subscribe({
        next: (response) => {
          if (response) {
            this.updateContactverificationDate();
            this.sendEmail();
          }
          else {
            this.spinner.hide();
            this.cService.contactVerificationFailed = true;
          }
        },
        error: (error) => {
          console.log(error);
          this.spinner.hide();
          this.cService.contactVerificationFailed = true;
        }
      });
    }
  }
  syncDataToMdm() {
    let userUuid = this.cService.tokenDtls.userUuid
    this.cDataService.syncDataToMdm(userUuid).subscribe({
      next: (response) => {
      },
      error: (errorobj) => console.error("In syncDataToMdm: ", errorobj.error)
    })
  }
  sendEmail() {
    let exemails = [...new Set(this.cService.oedsPersonCopy.emailList.map(x => x.exEmail))];
    let emails = [...new Set(this.cService.oedsPersonCopy.emailList.map(x => x.email))];
    let finalEmailList = [...new Set(exemails.concat(emails))];
    this.cDataService.sendEmail(finalEmailList).subscribe({
      next: (response) => {
      },
      error: (errorobj) => console.error("In Send Email: ", errorobj.error)
    })
  }
}

